import React from "react";
import DismissableModal from "components/DismissableModal";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import AiCallResults from "./AiCallResults";
import "./AiCallResults.css";

const ExpandAiCallResults = (props) => {
  const { callDetailsList, callGroupId } = props;
  
  if (!callDetailsList || callDetailsList.length === 0) {
    return null;
  }

  return (
    <DismissableModal
      openModalButtonText="AI Call Results"
      openModalButtonStyle="info"
      openModalButtonClassName="btn-text-white btn-block"
      title="AI Call Results"
      size="xl"
      centered
      openModalButtonTestId="btn-ai-call-results"
    >
      <div className="modal-scrollable-content">
        <Container>
          <Row>
            <Col md={12}>
              <AiCallResults callDetailsList={callDetailsList} callGroupId={callGroupId} />
            </Col>
          </Row>
        </Container>
      </div>
    </DismissableModal>
  );
};

export default ExpandAiCallResults;
